module.exports = __webpack_public_path__ + "img/payment-systems.b9e11ba0.svg";